<template>
  <div class="form-group label-floating">
    <label v-if="label" class="control-label">
      {{label}}
    </label>
    <input :class="{'input': true, 'is-danger': errors.has(name), 'form-control': true, 'border-input': true }"
           v-validate="validations" 
           :data-vv-delay="delay"
           v-bind="$props"
           :value="value"
           @keyup.tab="input_has_changed"
           @input="$emit('input',$event.target.value)"
           @change="input_has_changed">
    <span v-show="errors.has(name)" class="form-group__message help is-danger">
        {{errors.first(name) }}
    </span>
  </div>

</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'text'
      },
      validations: '',
      delay: 0,
      label: String,
      name: String,
      disabled: Boolean,
      placeholder: String,
      value: [String, Number]
    },

    methods: {
      input_has_changed () {
        // console.log('input-has-changed: ' + this.name + ' , ' + this.errors.has(this.name))
        this.$emit('input-changed', this.name, this.errors.has(this.name))
      },
      tab_pressed: function (event) {
        console.log('press: ' + JSON.stringify(event))
      }
    },

    mounted: function () {
    //  if the input have a value already
    //  enabled or disabled the button properly
    // console.log('MOUNTED FORM' + this.value)
     if (this.value != '' && this.value != undefined) {
       this.$emit('input-changed', this.name, this.errors.has(this.name))     
     }
    },

    watch: {
     value: function (val) {
        this.input_has_changed()
      }
    }
  }

</script>
<style>

</style>


// WEBPACK FOOTER //
// formGroupInputValidate.vue?e9484f3a